import { ChangeDetectionStrategy, Component, input } from '@angular/core';

/** White panel with a titled header, a hairline divider, then body. */
@Component({
  selector: 'ui-card',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './ui-card.component.html',
})
export class UiCardComponent {
  readonly heading = input('');
  readonly description = input('');
  readonly bare = input(false);
}
